export default __webpack_public_path__ + "static/media/men-profile1.2c13be42.gif";